import {OrbitComponent} from '../orbit-component/orbit-component';

export class RoutedComponent<TProps> extends OrbitComponent<TProps> {
}
